(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px 12% 0px' }) : null;
  document.documentElement.classList.add('mt-js');

  function reveals() {
    document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('mt-visible');
    });
  }

  function comparadores() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (c) {
      if (c.dataset.mtInit) return; c.dataset.mtInit = '1';
      var r = c.querySelector('input');
      if (!r) return;
      r.addEventListener('input', function () { c.style.setProperty('--mt-pos', r.value + '%'); });
    });
  }

  function hotspots() {
    document.querySelectorAll('[data-mt-hot]').forEach(function (h) {
      if (h.dataset.mtInit) return; h.dataset.mtInit = '1';
      var els = h.querySelectorAll('[data-i]');
      function activar(i) { els.forEach(function (e) { e.classList.toggle('mt-activo', e.dataset.i === i); }); }
      els.forEach(function (e) {
        e.addEventListener('click', function () { activar(e.dataset.i); });
        e.addEventListener('mouseenter', function () { activar(e.dataset.i); });
      });
    });
  }

  function magneticos() {
    if (!window.matchMedia('(hover: hover)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-mt-magnetico]').forEach(function (b) {
      if (b.dataset.mtInit) return; b.dataset.mtInit = '1';
      b.addEventListener('mousemove', function (ev) {
        var r = b.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) / r.width * 8;
        var y = (ev.clientY - r.top - r.height / 2) / r.height * 6;
        b.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function galerias() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      if (g.dataset.mtInit) return; g.dataset.mtInit = '1';
      var main = g.querySelector('.mt-gal-main');
      g.querySelectorAll('.mt-gal-min button').forEach(function (b) {
        b.addEventListener('click', function () {
          main.src = b.dataset.src;
          main.removeAttribute('srcset');
          g.querySelectorAll('.mt-gal-min button').forEach(function (o) { o.classList.toggle('mt-activo', o === b); });
        });
      });
    });
  }

  function variantes() {
    document.querySelectorAll('[data-mt-compra]').forEach(function (f) {
      if (f.dataset.mtInit) return; f.dataset.mtInit = '1';
      var datos = f.querySelector('script[type="application/json"]');
      if (!datos) return;
      var vs = JSON.parse(datos.textContent);
      var sels = f.querySelectorAll('select[data-opcion]');
      var id = f.querySelector('input[name="id"]');
      var btn = f.querySelector('button[type="submit"]');
      var precio = f.querySelector('[data-mt-precio]');
      var textoBtn = btn.textContent;
      function cambiar() {
        var ops = Array.prototype.map.call(sels, function (s) { return s.value; });
        var v = vs.find(function (x) { return x.options.join('|') === ops.join('|'); });
        if (!v) { btn.disabled = true; btn.textContent = f.dataset.agotado; return; }
        id.value = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? textoBtn : f.dataset.agotado;
        if (precio) precio.textContent = v.precio;
      }
      sels.forEach(function (s) { s.addEventListener('change', cambiar); });
    });
  }

  function todo() { reveals(); comparadores(); hotspots(); magneticos(); galerias(); variantes(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  document.addEventListener('shopify:section:load', todo);
})();
